/**
 * Entri Persona - Quiz Definitions
 *
 * MCQ quizzes for each module and the final assessment.
 */

export const moduleQuizzes = {
  'functions-at-entri-quiz': {
    intro: "Now that you've learned about Entri's functions, let's take a short quiz to test your understanding. I'll read each question with 4 options. Please click your answer on the screen - voice answers are not supported for quizzes.",
    questions: [
      {
        question: "Which team is responsible for creating and maintaining the product features that users interact with?",
        options: [
          "Academics and Content",
          "Growth",
          "Engineering, Product and Design",
          "User Happiness"
        ],
        correctIndex: 2,
        explanation: "The Engineering, Product, and Design team is responsible for developing all aspects of Entri's products, including the features that users interact with. Their main focus is to ensure that the product delivers a high-quality user experience."
      },
      {
        question: "What is the main responsibility of the Academics and Content team?",
        options: [
          "Managing Financial reports",
          "Providing Placement assistance",
          "Designing and creating course syllabus and content",
          "Driving user acquisition and retention"
        ],
        correctIndex: 2,
        explanation: "The Academics and Content team is responsible for developing the educational materials, including well-structured syllabuses and content, to ensure that learners have a high-quality learning experience."
      },
      {
        question: "Which team ensures that users have a positive experience and are valued?",
        options: [
          "Media",
          "User Happiness",
          "Inside Sales",
          "Finance and Accounting"
        ],
        correctIndex: 1,
        explanation: "The User Happiness team is dedicated to making sure that users feel satisfied and valued by addressing their concerns promptly and ensuring a positive interaction throughout their journey with Entri."
      },
      {
        question: "The Media team is responsible for:",
        options: [
          "Creating educational content and managing placements",
          "Financial budgeting and payroll management",
          "Producing in-app videos and managing content on platforms like YouTube",
          "Overseeing recruitment and employee training"
        ],
        correctIndex: 2,
        explanation: "The Media team focuses on creating and managing engaging content, including in-app videos and social media materials, such as content for YouTube. Their role is to create promotional and educational content across all platforms."
      },
      {
        question: "Which team works closely with industry partners to assist learners with job placements?",
        options: [
          "Engineering, Product, and Design",
          "Placements",
          "Inside Sales",
          "Administration and Operations"
        ],
        correctIndex: 1,
        explanation: "The Placements team is responsible for helping learners transition from education to employment by offering job placement assistance, resume building, and interview preparation, while also working closely with industry partners."
      },
      {
        question: "What is the focus of Entri's Growth team?",
        options: [
          "Managing human resources and employee benefits",
          "Generating creative media content",
          "Driving user acquisition and retention through data and marketing",
          "Ensuring customer happiness and resolving user issues"
        ],
        correctIndex: 2,
        explanation: "The Growth team focuses on expanding Entri's user base by using data-driven strategies, marketing campaigns, and partnerships to attract new users and retain current ones, which is essential for the company's overall business goals."
      },
      {
        question: "What is the largest team at Entri that focuses on reaching out to potential clients and driving revenue?",
        options: [
          "Growth",
          "Inside Sales",
          "Placement",
          "Finance and Accounting"
        ],
        correctIndex: 1,
        explanation: "Inside Sales is the largest team at Entri, responsible for driving revenue by reaching out to potential clients, qualifying leads, and supporting the company's overall growth. They focus on user acquisition and delivering excellent service."
      },
      {
        question: "Which function ensures that Entri complies with labor laws and manages employee benefits?",
        options: [
          "Finance and Accounting",
          "Human Resources",
          "Administration and Operations",
          "Founder's Office"
        ],
        correctIndex: 1,
        explanation: "The Human Resources (HR) team ensures compliance with labor laws and manages employee relations, benefits, recruitment, and training. They play a vital role in maintaining a positive work environment."
      }
    ]
  },
  'founder-video-quiz': {
    intro: "Now that you have seen the video, let's take a short quiz to test your understanding. I'll read each question with 4 options. Please click your answer on the screen - voice answers are not supported for quizzes.",
    questions: [
      {
        question: "What is the main goal of Entri as a learning platform?",
        options: [
          "Entertainment and content creation",
          "Job oriented learning and skill development",
          "Social Media Engagement",
          "Freelance Opportunities for educators"
        ],
        correctIndex: 1,
        explanation: "Entri is a learning app that caters to job aspirants, offering preparation content to help users secure Government or Private Jobs."
      },
      {
        question: "In which State was Entri started?",
        options: [
          "Tamil Nadu",
          "Karnataka",
          "Kerala",
          "Andhra Pradesh"
        ],
        correctIndex: 2,
        explanation: "Entri was established in Kerala with Malayalam as its primary language before expanding to other languages and regions."
      },
      {
        question: "How does Entri ensure personalized learning?",
        options: [
          "By providing content only in English",
          "Through automatic adaptation to each learner's skill level, time availability and language preference",
          "By focusing only on government jobs",
          "By collaborating with international educators"
        ],
        correctIndex: 1,
        explanation: "Entri ensures personalized learning by automatically adapting its courses to match each learner's skill level, time availability, and language preference."
      },
      {
        question: "When was the Entri App established?",
        options: [
          "2015",
          "2016",
          "2017",
          "2018"
        ],
        correctIndex: 2,
        explanation: "Entri was founded in 2017, marking the beginning of its journey as a learning app focused on providing vernacular content to job aspirants in India."
      },
      {
        question: "In which states does Entri have offices?",
        options: [
          "Kerala, Karnataka, Tamil Nadu, Delhi",
          "Maharashtra, Gujarat, Rajasthan",
          "West Bengal, Odisha, Assam",
          "Delhi, Uttar Pradesh, Madhya Pradesh"
        ],
        correctIndex: 0,
        explanation: "Entri's main headquarters is in Kakkanad, Kerala, where the company began its operations and continues coordinating its core activities, later expanded to other regions."
      },
      {
        question: "What does Entri prioritize in its mission to help users secure jobs?",
        options: [
          "Physical Fitness",
          "Skill Development and Training",
          "Entertainment",
          "High Speed Internet Access"
        ],
        correctIndex: 1,
        explanation: "Entri focuses on skill development and training to help users secure jobs and improve their quality of life."
      },
      {
        question: "What is Entri's vision for the future?",
        options: [
          "To provide learning materials in multiple languages without focusing on job outcome",
          "To become the largest job oriented vernacular learning app in India targeting 4 crore users by 2027",
          "To expand globally and reach 1 crore users in various countries by 2025",
          "To cater exclusively to government job aspirants in India"
        ],
        correctIndex: 1,
        explanation: "Entri's vision is to become the largest job-oriented vernacular learning app in India, targeting 4 crore users by 2027."
      },
      {
        question: "Who are Entripreneurs at Entri?",
        options: [
          "Users who subscribe to Entri's learning platform",
          "Employees of Entri who are driven by a founder mindset and ownership",
          "Trainers who curate exam oriented materials",
          "Employees who have completed five years of service"
        ],
        correctIndex: 1,
        explanation: "The term Entripreneurs refers to Entri employees who embody the values of ownership and a founder-like mindset."
      },
      {
        question: "What does the term Legend represent at Entri?",
        options: [
          "Exceptional employees who have completed 5 years of service",
          "Trainers who have created the most study materials for the platform",
          "Employees who embody the founder mindset at the company",
          "Users who have subscribed to Entri for five years"
        ],
        correctIndex: 0,
        explanation: "Legends at Entri refers to employees who have completed five years of service and made significant contributions to the company's growth."
      }
    ],
    passingScore: 6,
    completionMessage: "Great job completing the Entri quiz! You now have a good understanding of our company. Let's continue with the next topic."
  },

  'hr-policies-quiz': {
    intro: "Now that you've learned about HR Policies, let's take a short quiz to test your understanding. I'll read each question with 4 options. Please click your answer on the screen - voice answers are not supported for quizzes.",
    questions: [
      {
        question: "How many earned leaves can an employee carry forward per year?",
        options: [
          "10",
          "20",
          "30",
          "40"
        ],
        correctIndex: 2,
        explanation: "Employees are granted 18 earned leaves annually, with 1.5 leaves credited monthly."
      },
      {
        question: "Which software is used for internal communication within the company?",
        options: [
          "Jira",
          "Slack",
          "Gsuite",
          "Gitlab"
        ],
        correctIndex: 1,
        explanation: "Slack is designated as the official platform for internal communication."
      },
      {
        question: "How many days of wedding leave are granted to eligible employees?",
        options: [
          "3 days",
          "5 days",
          "7 days",
          "10 days"
        ],
        correctIndex: 1,
        explanation: "Eligible team members are granted 5 days of wedding leave."
      },
      {
        question: "How many sick leaves are employees granted annually at Entri?",
        options: [
          "10 days",
          "8 days",
          "6 days",
          "5 days"
        ],
        correctIndex: 2,
        explanation: "Entri grants employees 6 sick leaves annually, credited at the beginning of the year."
      },
      {
        question: "Comp Off can be claimed for working on which of the following?",
        options: [
          "Sick days",
          "Public Holidays or Weekends",
          "Personal Holidays",
          "Paid Time off"
        ],
        correctIndex: 1,
        explanation: "Employees can apply for Comp Off when they work on public holidays or weekends."
      },
      {
        question: "What is the total number of holidays (mandatory, regional, and festival) provided annually?",
        options: [
          "10",
          "19",
          "15",
          "18"
        ],
        correctIndex: 2,
        explanation: "The company provides 15 holidays annually, including mandatory, regional, and festival holidays."
      },
      {
        question: "How many days of paternity leave are provided for new fathers?",
        options: [
          "3",
          "5",
          "7",
          "10"
        ],
        correctIndex: 1,
        explanation: "New fathers are eligible for 5 days of paternity leave."
      }
    ],
    passingScore: 5,
    completionMessage: "Excellent work! You've completed the HR Policies quiz. Let's continue with the next topic."
  },

  'posh-quiz': {
    intro: "Now that you've watched the POSH video, let's take a quiz to test your understanding. I'll read each question with 4 options. Please click your answer on the screen - voice answers are not supported for quizzes.",
    questions: [
      {
        question: "What does POSH stand for?",
        options: [
          "Protection of Staff Health",
          "Prevention of Sexual Harassment",
          "Policy on Staff Happiness",
          "Procedures for Office Safety"
        ],
        correctIndex: 1,
        explanation: "POSH stands for Prevention of Sexual Harassment. The goal of POSH is to ensure a safe and respectful environment for all employees, protecting them from unwanted and inappropriate behavior."
      },
      {
        question: "Who can be a victim of sexual harassment?",
        options: [
          "Only full-time employees",
          "Only female employees",
          "Any employee, regardless of their gender or employment status",
          "Only temporary and contract workers"
        ],
        correctIndex: 2,
        explanation: "Anyone in the workplace, regardless of their gender or employment status, can be a victim of sexual harassment. This includes full-time, part-time, temporary, and contract workers."
      },
      {
        question: "Is your complaint kept confidential in the POSH process?",
        options: [
          "No, your complaint details will be shared with everyone in the company.",
          "Yes, but only if the complaint is deemed serious.",
          "Yes, confidentiality is a key principle of the POSH process, and your complaint details will be kept confidential to protect your privacy.",
          "No, the details are publicly disclosed once the investigation starts."
        ],
        correctIndex: 2,
        explanation: "In the POSH process, confidentiality is a key principle to protect the privacy of those involved. This means that when you file a complaint, the details are kept confidential and shared only with those directly involved in the investigation."
      },
      {
        question: "If an employee experiences sexual harassment, whom should they approach within the POSH process?",
        options: [
          "Their colleagues",
          "The Human Resources department or Internal Committee",
          "The senior involved in the violence",
          "The company's security team"
        ],
        correctIndex: 1,
        explanation: "If an employee experiences sexual harassment, they should approach the Human Resources department or the Internal Committee. These are the designated bodies within the POSH framework responsible for handling such complaints, conducting investigations, and ensuring appropriate actions are taken."
      },
      {
        question: "What constitutes a sexual harassment?",
        options: [
          "Inappropriate jokes or comments",
          "Unwanted physical contact",
          "Display of offensive materials",
          "All of the Above"
        ],
        correctIndex: 3,
        explanation: "All of the above. Sexual harassment includes any unwelcome behavior of a sexual nature that creates a hostile or intimidating work environment."
      },
      {
        question: "What should I do if I experience or witness sexual harassment?",
        options: [
          "Ignore the incident and hope it stops",
          "Report the incident immediately to the Internal Complaints Committee (ICC) or your HR department",
          "Document the details of the incident, including dates, times, and any witnesses",
          "Both B and C"
        ],
        correctIndex: 3,
        explanation: "Both B and C. If you experience or witness sexual harassment, immediately report the incident to HR or the Internal Complaints Committee to ensure a formal investigation and accountability. Simultaneously, document all details—including dates, times, and witnesses—to provide an essential evidentiary record that supports your case."
      },
      {
        question: "What is the role of the Internal Complaints Committee (ICC)?",
        options: [
          "Receiving and investigating complaints",
          "Ensuring confidentiality throughout the process",
          "Taking appropriate actions based on the findings",
          "All of the above"
        ],
        correctIndex: 3,
        explanation: "All of the above. The ICC maintains a safe workplace by investigating harassment complaints thoroughly while ensuring strict confidentiality to protect all parties. They are also responsible for implementing disciplinary actions against perpetrators to ensure professional accountability and a respectful environment."
      },
      {
        question: "How is a complaint investigated?",
        options: [
          "Conduct a thorough investigation, which may include interviews with the complainant, the accused, and any witnesses",
          "Review any relevant evidence",
          "Provide both parties with an opportunity to present their case",
          "All of the above"
        ],
        correctIndex: 3,
        explanation: "All of the above. The ICC ensures a fair investigation by interviewing all parties, reviewing physical evidence, and allowing both the complainant and accused to present their cases. This multifaceted approach culminates in a comprehensive report with findings and recommendations."
      },
      {
        question: "What actions can be taken if someone is found guilty of sexual harassment?",
        options: [
          "Transfer or change in role",
          "Suspension or termination of employment",
          "Legal action if necessary",
          "All of the above"
        ],
        correctIndex: 3,
        explanation: "All of the above. When an individual is found guilty of sexual harassment, the company must take decisive action to ensure workplace safety. Depending on the severity, responses range from formal warnings and role transfers to suspension or termination. In cases involving legal violations, the company may also pursue litigation to ensure full accountability and maintain a respectful environment."
      }
    ],
    passingScore: 6,
    completionMessage: "Excellent! You've completed the POSH quiz. Let's move on to the next topic."
  },

  'employee-benefits-quiz': {
    intro: "Now that you've learned about Employee Benefits, let's take a quick quiz to test your understanding. I'll read each question with 4 options. Please click your answer on the screen - voice answers are not supported for quizzes.",
    questions: [
      {
        question: "What is the insured amount offered under the group medical insurance for employee, spouse and children?",
        options: [
          "2 Lakhs",
          "3 Lakhs",
          "5 Lakhs",
          "10 Lakhs"
        ],
        correctIndex: 2,
        explanation: "5 lakhs. Under the group medical insurance program, employees at Entri receive medical coverage of rupees 5 lakhs for their families through Niva Bupa."
      },
      {
        question: "What does YourDOST offer to Entri employees?",
        options: [
          "Financial support",
          "Medical insurance",
          "Counseling and emotional support",
          "Book club discussion"
        ],
        correctIndex: 2,
        explanation: "Counseling and emotional support. YourDOST is a comprehensive mental health and well-being platform designed to provide support and resources for individuals facing emotional and psychological challenges."
      },
      {
        question: "How long does a referred candidate need to work at Entri for the referring employee to receive the referral bonus?",
        options: [
          "1 month",
          "2 months",
          "3 months",
          "6 months"
        ],
        correctIndex: 2,
        explanation: "3 months. The referral bonus is given to team members once the referred candidate completes 3 successful months of employment at Entri."
      },
      {
        question: "How often is the book allowance reimbursed to employees for the Entri Book Club?",
        options: [
          "Monthly",
          "Quarterly",
          "Annually",
          "Bi-annually"
        ],
        correctIndex: 1,
        explanation: "Quarterly. Employees receive a quarterly allowance to purchase books for the Entri Book Club, where they can discuss and share their reading experiences with colleagues."
      },
      {
        question: "Who is covered under the Group Medical Insurance plan provided by Entri?",
        options: [
          "Only the employee",
          "Employee and spouse",
          "Employee, spouse and children",
          "Employee and parents"
        ],
        correctIndex: 2,
        explanation: "Employee, spouse, and children. The Group Medical Insurance provided by Entri covers the employee, their spouse, and children."
      }
    ],
    passingScore: 3,
    completionMessage: "Great job! You've completed the Employee Benefits quiz. Let's continue with the next topic."
  },

  'final-quiz': {
    intro: "This is the final quiz. I'll ask you a few questions to see how much you've learned about Entri. Please click your answer on the screen - voice answers are not supported for quizzes.",
    questions: [
      {
        question: "What is the main goal of Entri as a learning platform?",
        options: [
          "Entertainment content creation",
          "Job-oriented learning and skill development",
          "Social media engagement",
          "Freelance opportunities for educators"
        ],
        correctIndex: 1,
        explanation: "Job-oriented learning and skill development. Entri is India's leading learning platform focused on helping job seekers prepare for competitive exams, learn new skills, and advance their careers."
      },
      {
        question: "Which of the following verticals is primarily focused on preparing students for competitive exams?",
        options: [
          "Study Abroad",
          "Skilling",
          "Test Prep",
          "Finacademy"
        ],
        correctIndex: 2,
        explanation: "Test Prep. The Test Prep vertical is dedicated to helping candidates prepare for competitive exams like PSC, SSC, Banking, and Railway exams."
      },
      {
        question: "Which software is used for internal communication within the company?",
        options: [
          "Jira",
          "Slack",
          "Gsuite",
          "Gitlab"
        ],
        correctIndex: 1,
        explanation: "Slack is designated as the official platform for internal communication at Entri."
      },
      {
        question: "Is your complaint kept confidential in the POSH process?",
        options: [
          "No, your complaint details will be shared with everyone in the company.",
          "Yes, but only if the complaint is deemed serious.",
          "Yes, confidentiality is a key principle of the POSH process, and your complaint details will be kept confidential to protect your privacy.",
          "No, the details are publicly disclosed once the investigation starts."
        ],
        correctIndex: 2,
        explanation: "Yes, confidentiality is a key principle in the POSH process. When you file a complaint, the details are kept confidential and shared only with those directly involved in the investigation."
      },
      {
        question: "Which team is responsible for creating and maintaining the product features that users interact with?",
        options: [
          "Academics and Content",
          "Growth",
          "Engineering, Product, and Design",
          "User Happiness"
        ],
        correctIndex: 2,
        explanation: "The Engineering, Product, and Design team is responsible for developing all aspects of Entri's products, including the features that users interact with."
      }
    ],
    passingScore: 3,
    completionMessage: "You've now completed your onboarding. ... I'll always be here to help, so feel free to ask me anything related to the company whenever you need. ... We're excited to have you on the team. ... Welcome aboard, and all the best as you get started!"
  },
};

export const finalQuiz = {
  intro: "It's time for the final quiz. I'll ask you a few questions to see how much you've learned about Entri. Please click your answer on the screen - voice answers are not supported for quizzes.",
  questions: [
    {
      question: "How many users does Entri have?",
      correctAnswer: "1.4 crore",
      keywords: ["1.4 crore", "1.4 crore+", "1.4", "crore", "14 million", "14 million users"],
      topic: "About Entri"
    },
    {
      question: "What does POSH stand for?",
      correctAnswer: "Prevention of Sexual Harassment",
      keywords: ["posh", "prevention", "sexual harassment", "workplace", "prevention of sexual harassment"],
      topic: "POSH"
    },
    {
      question: "What is the quarterly allowance for the Entri Book Club?",
      correctAnswer: "500 rupees",
      keywords: ["500", "₹500", "500 rupees", "five hundred", "quarterly"],
      topic: "Employee Benefits"
    },
    {
      question: "What should you do if you experience an uncomfortable situation at work?",
      correctAnswer: "report to posh committee",
      keywords: ["report", "posh", "committee", "contact", "reach out", "email", "report to posh"],
      topic: "Company Rules"
    },
    {
      question: "What does it mean to be an Entripreneur?",
      correctAnswer: "entri employee",
      keywords: ["entripreneur", "entri employee", "part of entri", "entri family", "team member"],
      topic: "Work Culture"
    }
  ],
  passingScore: 3,
  completionMessage: "You've now completed your onboarding. ... I'll always be here to help, so feel free to ask me anything related to the company whenever you need. ... We're excited to have you on the team. ... Welcome aboard, and all the best as you get started!"
};

const entriQuizzes = {
  moduleQuizzes,
  finalQuiz,
};

export default entriQuizzes;
